Greenmile.Checks = Greenmile.Checks || {};
Greenmile.Checks.EventCheck = Greenmile.Checks.EventCheck || {};

Greenmile.Checks.EventCheck.MovementNotAllowed = {

    template() {
    
        return {
          tag: 'div',
          items: [
            {
              items: [
                {
                  items: [
                    {
                      items: [
                        {
                            items: [
                            {
                                'tag': 'input',
                                 attributes: {
                                    "type": 'checkbox',
                                    "name": 'lunchChoice',
                                    "id": 'lunch-checkbox',
                                    "class": 'modelAttribute checkboxField mandatory',
                                    "checked": 'true',
                                },
                            },
                            {
                                tag: 'label',
                                items: [
                                {
                                    tag: 'span',
                                    html: '',
                                    attributes: {
                                        class: 'i18nResource',
                                        id: 'lunch-radius-label',
                                        },
                                    },
                                ],
                                attributes: {
                                class: 'control-label',
                                id: 'lunch-value',
                                for: 'lunch-radius',
                                },
                            },
                        ],
                        attributes: {
                            class: 'controls',
                        },
                    },
                        {
                            tag: 'input',
                            attributes: {
                                type: 'text',
                                'name': 'lunchRadius',
                                'maxlength': '10',
                                alt: '',
                                'value': '',
                                size: '11',
                                id: 'lunch-radius',
                                class: 'modelAttribute textField numberPicker mandatory',
                                'autocomplete': 'off',
                                "checked": 'false',
                            },
                        },
                      ],
                    },
                    {
                      items: [
                        {
                            items: [
                                {
                          'tag': 'input',
                          attributes: {
                            "type": 'checkbox',
                            "name": 'offDutyChoice',
                            "id": 'offduty-checkbox',
                            "class": 'modelAttribute checkboxField mandatory',
                          },
                        },
                        {
                          tag: 'label',
                          attributes: {
                            "id": 'offduty-radius-label',
                          },
                          'items': [
                            {
                              "tag": 'span',
                              "html": Monet.I18n.getResourcesByKey('event.check.movementNotAllowed.offDutyRadius'),
                            },
                          ],
                        },
                    ],
                    attributes: {
                        class: 'controls',
                    },
                },
                        {
                          'tag': 'input',
                          attributes: {
                            "type": 'text',
                            "step": '1',
                            "id": 'offduty-radius',
                            size: '11',
                            class: 'modelAttribute textField numberPicker mandatory',
                            "disabled": "true",
                          },
                        },
                        
                      ],
                    },
                  ],
                  attributes: {
                    class: 'controls',
                  },
                },
              ],
              attributes: {
                class: 'control-group movement-not-allowed',
              },
            },
          ],
        };
      },
    

    assignParameter(jsonParam) {
        let lunchValue, lunchFormatedValue, offdutyValue, offdutyFormatedValue;

        const checkboxLunch =  document.querySelector('.movement-not-allowed #lunch-checkbox' );
        const lunchRadius =  document.querySelector('.movement-not-allowed #lunch-radius' );
        const checkboxOffduty =  document.querySelector('.movement-not-allowed #offduty-checkbox' );
        const offdutyRadius =  document.querySelector('.movement-not-allowed #offduty-radius' );

        const disableFieldsRadius = ({ toEnable } ) => {
            if (checkboxLunch.checked){
                toEnable.disabled = false;
            } else{
                toEnable.disabled = true;
                toEnable.value = '';
            }
        };

        const disableFieldsChoice = ({ toEnable } ) => {
            if (checkboxOffduty.checked){
                toEnable.disabled = false;
            } else{
                toEnable.disabled = true;
                toEnable.value = '';
            }
        };

        const disableOffdutyFields = () => {
            disableFieldsChoice({ toEnable: offdutyRadius } );
        }
        const disableLunchFields = () => {
            disableFieldsRadius({ toEnable: lunchRadius} );
        };
      
        checkboxLunch.addEventListener('click',disableLunchFields );
        checkboxOffduty.addEventListener('click', disableOffdutyFields);
        

        if (jsonParam) {
            jsonParam = JSON.parse(jsonParam);

           

            if (Monet.Session.User.unitSystem !== 'METRIC') {
                
                if(jsonParam.lunchChoice){
                    lunchValue = new BigInt(jsonParam.lunchRadius) * 0.00062137;
                    lunchFormatedValue = ((Math.round(lunchValue * 100)) / 100);
                    checkboxLunch.checked = true;
                    lunchRadius.disabled = false;
                } else{
                    checkboxLunch.checked = false;
                    lunchRadius.disabled = true;
                }
                if(jsonParam.offDutyChoice){
                    offdutyValue = new BigInt(jsonParam.offDutyRadius) * 0.00062137;
                    offdutyFormatedValue = ((Math.round(offdutyValue * 100)) / 100);
                    checkboxOffduty.checked = true;
                    offdutyRadius.disabled = false;
                } else{
                    checkboxOffduty.checked = false;
                    offdutyRadius.disabled = true;
                }
            } else {
                
                if(jsonParam.lunchChoice){
                    lunchFormatedValue = jsonParam.lunchRadius;
                    checkboxLunch.checked = true;
                    lunchRadius.disabled = false;
                } else{
                    checkboxLunch.checked = false;
                    lunchRadius.disabled = true;
                }
                if(jsonParam.offDutyChoice){
                    offdutyFormatedValue = jsonParam.offDutyRadius;
                    checkboxOffduty.checked = true;
                    offdutyRadius.disabled = false;
                } else{
                    checkboxOffduty.checked = false;
                    offdutyRadius.disabled = true;
                }
            }

            $('#offduty-radius').val(offdutyFormatedValue)
            $('#lunch-radius').val(lunchFormatedValue);

        } 

        if (Monet.Session.User.unitSystem !== 'METRIC') {
            document.getElementById('lunch-radius-label').innerText = Monet.I18n.getResourcesByKey('event.check.movementNotAllowed.lunchRadius') + ' (mi)';
            document.getElementById('offduty-radius-label').innerText = Monet.I18n.getResourcesByKey('event.check.movementNotAllowed.offDutyRadius') + ' (mi)';
        } else {
            document.getElementById('lunch-radius-label').innerText = Monet.I18n.getResourcesByKey('event.check.movementNotAllowed.lunchRadius') + ' (m)';
            document.getElementById('offduty-radius-label').innerText = Monet.I18n.getResourcesByKey('event.check.movementNotAllowed.offDutyRadius') + ' (m)';
        }
        
    },

    retrieveParameter() {
        let lunchRadius, lunchValue, offDutyRadius, offDutyValue;

        const checkboxOffduty =  document.querySelector('.movement-not-allowed #offduty-checkbox' );
        const checkboxLunch =  document.querySelector('.movement-not-allowed #lunch-checkbox' );

        if(checkboxLunch.checked){
            if (Monet.Session.User.unitSystem !== 'METRIC') {
                lunchValue = $('#lunch-radius').val() / 0.00062137;
            } else {
                lunchValue = $('#lunch-radius').val();
            }
    
            lunchRadius = parseInt(lunchValue, 10);
        }
        

        if(checkboxOffduty.checked){
            if (Monet.Session.User.unitSystem !== 'METRIC') {
                offDutyValue = $('#offduty-radius').val() / 0.00062137;
            } else {
                offDutyValue = $('#offduty-radius').val();
            }
    
            offDutyRadius = parseInt(offDutyValue, 10);
        }

        return JSON.stringify({
            lunchRadius: lunchRadius,
            offDutyRadius: offDutyRadius,
            lunchChoice: checkboxLunch.checked,
            offDutyChoice: checkboxOffduty.checked 
        });
    },
};